export const sumPoints = (points: number[]): number => {
  return points.reduce((prev, current) => prev + current, 0);
};
